module.exports = __webpack_public_path__ + "img/horizontal_4_5_9005.a63e9a40.png";